export const IP_LOOKUP_ENDPOINT = 'https://wtcfns.hubspot.com/ip-lookup';
export const doIpLookup = () => {
  return new Promise((resolve, reject) => {
    fetch(IP_LOOKUP_ENDPOINT).then(response => {
      if (response.ok) {
        return response.json();
      } // Fetch promises only reject with a TypeError when a network error occurs.
      // Since 4xx and 5xx response arent network errors, we should throw an error to catch it.


      throw new Error(`Status ${response.status} from ${response.url}`);
    }).then(result => {
      resolve(result.GeoIpInfo.country);
    }).catch(error => {
      reject(new Error(`IP lookup request failed. ${error.message}. ${error.status}`));
    });
  });
};